import React from 'react';
import './header.css';

const HeaderSpace = () => {
  return (
    <div className={'headerSpace'}/>
  )
}

export default HeaderSpace